import { countryLanguages } from '../language/countries';
import { selectLanguage } from '../language/LanguageSlice';
import { useTypedSelector } from '../redux/store';

export function useLanguage() {
  const { languageIndex } = useTypedSelector((state) => selectLanguage(state));
  const lang = countryLanguages[languageIndex].lang;
  return lang;
}
